import { RicosPluginToolbarNames } from 'ricos-types';
import type { EditorPluginCreator } from 'wix-rich-content-common';

import { DEFAULTS } from './defaults';
import { getAddButtons } from './getAddButtons';
import { getToolbarButtons } from './getToolbarButtons';
import { InsertModal } from './modals/InsertModal';
import { SettingsModal } from './modals/SettingsModal';
import { tiptapExtensions } from './tiptap/tiptap';
import type { LinkPreviewPluginEditorConfig } from './types';
import { LINK_PREVIEW_TYPE } from './types';

export const pluginLinkPreview: EditorPluginCreator<
  LinkPreviewPluginEditorConfig,
  { InsertModal: typeof InsertModal; SettingsModal: typeof SettingsModal }
> = config => {
  const pluginConfig: LinkPreviewPluginEditorConfig = { ...DEFAULTS.config, ...config };
  return {
    config: pluginConfig,
    type: LINK_PREVIEW_TYPE,
    tiptapExtensions,
    getAddButtons: (config, services) => getAddButtons(config, services),
    toolbar: {
      names: [RicosPluginToolbarNames.LINK_PREVIEW, RicosPluginToolbarNames.EMBED],
      getButtons: (config, services) => getToolbarButtons(config, services),
    },
    __exports: {
      InsertModal,
      SettingsModal,
    },
  };
};
